import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../../shared/services/Session.service';

@Component({
  selector: 'configurationsPage',
  templateUrl: './configurationsPage.component.html',
  styleUrls: ['./configurationsPage.component.css']
})
export class ConfigurationsPageComponent implements OnInit {

  constructor(private sessionService: SessionService) { }
  
    ngOnInit(): void {
      this.sessionService.setIsExternalMap(false);
    }

}
